import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export const SourcePane = ({ projectId, item }) => {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let url, on = true;
    setSrc(null); setErr(false);
    api.get(`/projects/${projectId}/items/${item.id}/source`, { responseType: "blob" })
      .then(({ data }) => { url = URL.createObjectURL(data); if (on) setSrc(url); })
      .catch(() => on && setErr(true));
    return () => { on = false; if (url) URL.revokeObjectURL(url); };
  }, [projectId, item.id]);
  return (
    <div className="w-1/2 shrink-0 border-r border-slate-800 bg-white flex flex-col" data-testid="source-pane">
      <div className="h-8 px-3 flex items-center bg-[#0d1220] border-b border-slate-800 font-mono text-[10px] uppercase tracking-wider text-amber-300">
        Source joinery drawing · {item.tag} · page {item.source?.page}
      </div>
      <div className="flex-1 overflow-auto grid place-items-center p-3">
        {src ? <img src={src} alt={`Source ${item.tag}`} className="max-w-full max-h-[calc(100vh-150px)] object-contain" data-testid="source-pane-img" />
          : err ? <p className="text-xs text-slate-500">Source crop not available</p> : <Loader2 className="animate-spin text-cyan-500" />}
      </div>
    </div>
  );
};
